const PHONE_REGEX = /^(\+)?([ 0-9]){10,16}$/;

export default PHONE_REGEX;
